export default "__VITE_ASSET__Cck4YtSN__"